import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import MoreIcon from "@mui/icons-material/MoreVert";
import { Divider, Popover, Stack, Badge, Grid, List, ListItem } from "@mui/material";
import axios from "axios";
import { baseURL } from "../../api";
import MailIcon from "@mui/icons-material/Mail";
import { Icon } from "../../utils/MuiIcons/Icon";
import { Link, Navigate, useLocation, useParams } from "react-router-dom";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import SimpleListMenu from "../../component/SelectedMenu/SelectedMenu";
import { useNavigate } from "react-router-dom";
import { Global_Data } from "../../globalData/GlobalData";
import { serverAddress } from "../../config";
import { styled } from "@mui/material/styles";
import {
  isFormMenuItemDisabled,
  mergeActionDenial
} from "./formMenuPermissions";

// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 13,
    border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
    padding: "0 4px",
  },
}));

const FormBar = ({ toggle, item, menu, recordData }) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElWidge, setAnchorElWidge] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [index, setIndex] = React.useState(0);
  const [widgetMenu, setWidgetMenu] = React.useState([]);
  const [accountDetails, setAccountDetails] = React.useState();
  const [userInfo, setUserInfo] = React.useState();
  const [indexWidge, setIndexWidge] = React.useState(-1);
  const [printButtonDisabledStatus, setPrintButtonDisabledStatus] = React.useState(false);
  const [popoverId, setPopoverId] = useState();
  const [printCount, setPrintCount] = useState(-1);
  const [menuDisabledStatus, setMenuDisabledStatus] = useState({});
  const [workflowRecordKey, setWorkflowRecordKey] = useState("");

  const {
    token,
    // formData,
    // overlaySplit
    formData,
    handleClickOpen,
    sideBarStyle,
    overlaySplit,isDialogDrawerOpen,
    setEditApi,
    setOpen,textValue,  setOverLaySplit,
    setReportPrintUpdate,
    setModalActionTypeAndID,
    setDefaultTableSelectedLocation,
    setDefaultTableSelectedDataAwareData,
    setDefaultTableSelectedSupplier
  } = Global_Data();
  // const { token, globalvariables ,sideBarStyle} = Global_Data();

  const location = useLocation();
  const navigate = useNavigate();
  const ownerFormData = item || formData;
  const ownerModule = ownerFormData?.form?.sFormName || "";
  const ownerAction = ownerFormData?.form?.sFormAction || "";
  const currentMainRecord = recordData?.data?.mainrecord || {};
  const currentRecordKey = [
    currentMainRecord?.[ownerFormData?.form?.sPrimaryKey],
    currentMainRecord?.sDocStatus
  ].join("|");

  const getMenuParameterValues = () => {
  const mainRecord =
    recordData?.data?.mainrecord ||
    recordData?.mainrecord ||
    {};

  return {
  ...(textValue || {}),
  ...mainRecord,

    /*
     * Generic alias used by routes such as:
     * /purchase/po/cancel/[doc]
     */
    doc:
      mainRecord?.doc ??
      mainRecord?.sDocNumber ??
      textValue?.doc ??
      textValue?.sDocNumber ??
      ""
  };
};

const resolveMenuRoute = routeTemplate => {
  if (!routeTemplate) {
    return "";
  }

  const parameterValues = getMenuParameterValues();

  let resolvedRoute = String(routeTemplate).trim();

  /*
   * Preserve the existing POST: route convention,
   * but remove the prefix before navigation.
   */
  if (resolvedRoute.startsWith("POST:/")) {
    resolvedRoute = resolvedRoute.replace(/^POST:/, "");
  }

  /*
   * Replace only explicit placeholders.
   *
   * Supported:
   * [doc]
   * [sDocNumber]
   * {doc}
   * {sDocNumber}
   */
  resolvedRoute = resolvedRoute.replace(
    /\[([^\]]+)\]|\{([^}]+)\}/g,
    (match, squareKey, curlyKey) => {
      const key = String(
        squareKey || curlyKey || ""
      ).trim();

      const value = parameterValues?.[key];

      if (
        value === undefined ||
        value === null ||
        String(value).trim() === ""
      ) {
        console.warn(
          "[formmenu.js] Missing menu route parameter",
          {
            routeTemplate,
            key,
            parameterValues
          }
        );

        return match;
      }

      return encodeURIComponent(
        String(value).trim()
      );
    }
  );

  return resolvedRoute;
};

const hasUnresolvedMenuParameter = route => {
  return /\[[^\]]+\]|\{[^}]+\}/.test(
    String(route || "")
  );
};

const refreshPrintCounter = async navItem => {
  const verifyUri = resolveMenuRoute(navItem?.sMenuVerify);

  if (!verifyUri || hasUnresolvedMenuParameter(verifyUri)) {
    console.warn("[formmenu.js] PRINT verification route is unavailable", {
      routeTemplate: navItem?.sMenuVerify,
      resolvedRoute: verifyUri
    });
    return;
  }

  const response = await fetch(`${baseURL}${verifyUri}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Unable to refresh print counter (${response.status})`);
  }

  const result = await response.json();
  const nextCount = result?.data?.PrintCount ?? 0;
  const recordId =
    currentMainRecord?.[ownerFormData?.form?.sPrimaryKey] ??
    currentMainRecord?.sDocNumber;

  setPrintCount(nextCount);
  setPrintButtonDisabledStatus(result?.data?.Access !== "Yes");
  setReportPrintUpdate?.({
    reportId: result?.data?.ReportID,
    recordId,
    transactionId: currentMainRecord?.sDocNumber ?? recordId,
    status: result?.data?.Status ?? currentMainRecord?.sDocStatus,
    count: nextCount,
    updatedAt: Date.now()
  });
};

const openPrintReport = async navItem => {
  let uri = resolveMenuRoute(navItem?.sMenuRoute);

  if (!uri || hasUnresolvedMenuParameter(uri)) {
    console.error("[formmenu.js] PRINT route is invalid", {
      routeTemplate: navItem?.sMenuRoute,
      resolvedRoute: uri
    });
    return;
  }

  if (uri.endsWith("/")) {
    uri = uri.slice(0, -1);
  }

  const response = await fetch(`${baseURL}${uri}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Unable to render report (${response.status})`);
  }

  const blob = await response.blob();
  const objectURL = URL.createObjectURL(blob);
  const windowFeatures = "width=1300,height=700,left=100,top=100";
  window.open(objectURL, "_blank", windowFeatures);

  await refreshPrintCounter(navItem);
};

  const handleOpenNavMenu = event => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = event => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // for SubMenu
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //
  React.useEffect(() => {
    if (menu) {
      const uri = `${baseURL}${menu}`;
      axios
        .get(uri, {
          headers: {
            Authorization: `Bearer ${token}`
            // Other headers if needed
          }
        })
        .then(response => {
          setData(response.data.data.menu);
        })
        .catch(error => {
          console.log("Navbar Error", error);
        });
    }
  }, [menu]);
  // const { token, formData } = Global_Data();

  const [isRestricted, setRestricted] = useState(false);

  // function fetchActivity() {
  //   const urlCapture =
  //     serverAddress +
  //     `/form/isallowed/transaction?module=${formData.form.sFormName}&activity=${data?.component.options.action}`;
  //   axios
  //     .get(urlCapture, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //         // Other headers if needed
  //       }
  //     })
  //     .then(result => {

  //       if (result.data.data.Access == "No") {
  //         setRestricted(true);
  //       }
  //     })
  //     .catch(error => {
  //       console.error(error, "error456");
  //     });
  // }

  useEffect(() => {
    // Skip permission checks when form data is not loaded or in ADD mode
    if (!ownerModule || ownerAction === "ADD" || ownerAction === "add") return;

    const loadingStatus = {};
    const markLoading = items => {
      items?.forEach(menuItem => {
        if (menuItem?.sMenuID) loadingStatus[menuItem.sMenuID] = true;
        if (menuItem?.submenus?.length > 0) markLoading(menuItem.submenus);
      });
    };
    markLoading(data);
    SETBUTTONDIALOG(loadingStatus);
    fetchAccess(data);
    return () => {
      setRestricted(false);
    };
  }, [ownerModule, ownerAction, data, token]);

  // console.log(data);

  const getFieldValue = sName => {
    const [orgKey, fieldName] = sName?.split(".") ?? [];
    return userInfo?.data?.[fieldName];
  };
  const icon = widgetMenu[0]?.sImageType.replace("OutlinedIcon", "");

  const openWidge = Boolean(anchorElWidge);

  const handleOpenUserMenuWidge = event => {
    setAnchorElWidge(event.currentTarget);
  };

  const handleCloseWidge = event => {
    setAnchorElWidge(null);
  };


  function handleClickOpen1(navItem) {
    const dialogRoute = resolveMenuRoute(
      navItem?.sMenuRoute
    );

    if (!dialogRoute) {
      console.error(
        "[formmenu.js] BUTTONDIALOG route is empty",
        navItem
      );
      return;
    }

    if (hasUnresolvedMenuParameter(dialogRoute)) {
      console.error(
        "[formmenu.js] BUTTONDIALOG route contains unresolved parameter",
        {
          routeTemplate: navItem?.sMenuRoute,
          resolvedRoute: dialogRoute,
          navItem
        }
      );
      return;
    }

    const mode = {
      options: {
        mode: "DEFAULT",
        handler: "handleDialog",
        dialog: dialogRoute
      }
    };

    handleClickOpen(mode);
  }

  const [anchorEl1, setAnchorEl1] = React.useState(null);

  const handleClick2 = event => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl1(null);
  };

  const open1 = Boolean(anchorEl1);
  const id = open1 ? "simple-popover" : undefined;
  function parseMenuProps(sMenuProps) {
    try {
      const menuPropsObject = JSON.parse(sMenuProps);
      return menuPropsObject;
    } catch (error) {
      console.error("Error parsing :", error);
      return null;
    }
  }

  const downloadCsV = async (uri,name) => {
    try {
      const response = await axios.get(`${baseURL}${uri}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const csvContent = textToCsv(response.data);

      const blob = new Blob([csvContent], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${name}.csv`;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };

  function replaceBracketPlaceholders(uri, data) {
    const regex = /\[([^\]]+)\]/g;
    const replacedUri = uri?.replace(regex, (match, key) => {
      return key in (data || {}) ? data[key] : match;
    });
    return replacedUri;
  }

  useEffect(() => {
    // Skip menu verify calls when no record data (Add New mode)
    if (!recordData?.data?.mainrecord) return;
    let active = true;

    const fetchMenuAccess = async () => {
      if (data && data.length > 0) {
        const newStatus = {};
        const actionStatus = {};
        const loadingActionStatus = {};

        data.forEach(rowItem => {
          [
            rowItem?.sMenuID,
            rowItem?.sGlobalID,
            rowItem?.sMenuName
          ].filter(Boolean).forEach(key => {
            newStatus[key] = Boolean(rowItem?.sMenuVerify);
          });

          if (rowItem?.sMenuVerify && rowItem?.sAction) {
            loadingActionStatus[rowItem.sAction] = true;
          }
        });

        if (active) {
          setWorkflowRecordKey(currentRecordKey);
          setMenuDisabledStatus({ ...newStatus, ...loadingActionStatus });
        }

        for (const rowItem of data) {
          const verifyURI = rowItem?.sMenuVerify;

          if (verifyURI) {
            let uri = resolveMenuRoute(
              verifyURI
            );

            if (uri && !hasUnresolvedMenuParameter(uri)) {
              try {
                const requestOptions = {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                };
                const res = await fetch(`${baseURL}${uri}`, requestOptions);
                const result = await res.json();

                const disabled = result?.data?.Access !== "Yes";

                [
                  rowItem?.sMenuID,
                  rowItem?.sGlobalID,
                  rowItem?.sMenuName
                ].filter(Boolean).forEach(key => {
                  newStatus[key] = disabled;
                });

                Object.assign(
                  actionStatus,
                  mergeActionDenial(actionStatus, rowItem?.sAction, disabled)
                );

                if (rowItem.sAction === "PRINT") {
                  setPrintCount(result?.data?.PrintCount ?? 0);
                  setPrintButtonDisabledStatus(
                    result?.data?.Access === "Yes" ? false : true
                  );
                }
              } catch (error) {
                console.error("Verify fetch failed:", error);
                [
                  rowItem?.sMenuID,
                  rowItem?.sGlobalID,
                  rowItem?.sMenuName
                ].filter(Boolean).forEach(key => {
                  newStatus[key] = true;
                });
                Object.assign(
                  actionStatus,
                  mergeActionDenial(actionStatus, rowItem?.sAction, true)
                );
              }
            } else {
              [
                rowItem?.sMenuID,
                rowItem?.sGlobalID,
                rowItem?.sMenuName
              ].filter(Boolean).forEach(key => {
                newStatus[key] = true;
              });
              Object.assign(
                actionStatus,
                mergeActionDenial(actionStatus, rowItem?.sAction, true)
              );
            }
          } else {
            [
              rowItem?.sMenuID,
              rowItem?.sGlobalID,
              rowItem?.sMenuName
            ].filter(Boolean).forEach(key => {
              newStatus[key] = false;
            });
          }
        }
        if (active) {
          setMenuDisabledStatus({ ...newStatus, ...actionStatus });
        }
      }
    };

    fetchMenuAccess();
    return () => {
      active = false;
    };
  }, [
    data,
    currentRecordKey,
    token,
    baseURL,
    ownerModule
  ]);

  const isMenuDisabled = navItem => {
    const permissionRequired =
      Boolean(ownerModule) && ownerAction.toUpperCase() !== "ADD";
    const transactionPermissionKnown = Object.prototype.hasOwnProperty.call(
      BUTTONDIALOG,
      navItem?.sMenuID
    );
    const workflowConfiguredForAction = data?.some(menuItem =>
      menuItem?.sAction === navItem?.sAction && Boolean(menuItem?.sMenuVerify)
    );
    const workflowControlled = Boolean(
      navItem?.sMenuVerify || workflowConfiguredForAction
    );
    const workflowPermissionCurrent =
      !workflowControlled || workflowRecordKey === currentRecordKey;

    if (
      permissionRequired &&
      (
        !workflowPermissionCurrent ||
        (!workflowControlled && !transactionPermissionKnown)
      )
    ) {
      return true;
    }

    return isFormMenuItemDisabled(
      navItem,
      menuDisabledStatus,
      BUTTONDIALOG,
      workflowControlled
    );
  };

  const textToCsv = inputText => {
    const lines = inputText.split("\n");
    const header = lines[0].split(",").map(item => item.trim()); // Fix here
    const data = lines.slice(1).map(line => line.split(",").map(item => item.trim())); // Fix here
    const csvContent = [header.join(",")].concat(data.map(row => row.join(","))).join("\n");
    return csvContent;
  };

  const [BUTTONDIALOG, SETBUTTONDIALOG] = useState({});
  function fetchAccess(data, action) {
    for (let i = 0; i < data?.length; i++) {
      // SETBUTTONDIALOG(true)
      const urlCapture =
        serverAddress +
        `/form/isallowed/transaction?module=${ownerModule}&activity=${data[i].sAction}`;
      axios
        .get(urlCapture, {
          headers: {
            Authorization: `Bearer ${token}`
            // Other headers if needed
          }
        })
        .then(result => {
          //  alert(JSON.stringify(result.data.data.Access))
          if (result.data.data.Access == "No") {
            // setRestricted(true);
            SETBUTTONDIALOG(pre => ({ ...pre, [data[i].sMenuID]: true }));
          } else {
            SETBUTTONDIALOG(pre => ({ ...pre, [data[i].sMenuID]: false }));
          }
          if(data[i]?.submenus?.length > 0){
            fetchAccess(data[i]?.submenus);
          }
        })
        .catch(error => {
          console.error(error, "error456");
        });
    }
  }
  function handleIconDialog(navItem) {
    const routeTemplate = String(
      navItem?.sMenuRoute || ""
    ).trim();

    /*
    * Example:
    *
    * purchaseOrder_cancel_dialog?doc=[doc]
    *
    * Dialog component name:
    *
    * purchaseOrder_cancel_dialog
    */
    const dialogName = routeTemplate.split("?")[0];

    const dialogDefinition =
      ownerFormData?.details?.find(
        item =>
          item?.component?.sName === dialogName
      );

    if (!dialogDefinition) {
      console.error(
        "[formmenu.js] ICONDIALOG definition was not found",
        {
          dialogName,
          routeTemplate,
          formDetails: ownerFormData?.details
        }
      );

      return;
    }

    const currentUrl = new URL(
      window.location.href
    );

    const routeId =
      currentUrl.searchParams.get("id") || "";

    const dialogFormSource =
      dialogDefinition?.component?.sFormSource || "";

    /*
    * Only build an edit API when sFormSource exists.
    * Do not concatenate undefined/null with the ID.
    */
    if (dialogFormSource) {
      const editApi =
        routeId &&
        !dialogFormSource.endsWith(routeId)
          ? `${dialogFormSource}${routeId}`
          : dialogFormSource;

      setEditApi(editApi);
    } else {
      setEditApi("");
    }

    const dialogRoute = resolveMenuRoute(
      routeTemplate
    );

    if (!dialogRoute) {
      console.error(
        "[formmenu.js] ICONDIALOG route is empty",
        navItem
      );

      return;
    }

    if (
      hasUnresolvedMenuParameter(dialogRoute)
    ) {
      console.error(
        "[formmenu.js] ICONDIALOG route contains unresolved parameter",
        {
          routeTemplate,
          resolvedRoute: dialogRoute,
          navItem
        }
      );

      return;
    }

    const parameterValues =
      getMenuParameterValues();

    const primaryKeyName =
      dialogDefinition?.component?.sPrimaryKey ||
      ownerFormData?.form?.sPrimaryKey ||
      "";

    const primaryKeyValue =
      parameterValues?.[primaryKeyName] ??
      parameterValues?.doc ??
      routeId ??
      "";

    setModalActionTypeAndID({
      type:
        navItem?.sAction === "DELETE"
          ? "delete"
          : navItem?.sAction,

      id: primaryKeyValue,

      PrimaryKeyValue: primaryKeyValue,

      row: {
        ...(textValue || {}),
        ...(recordData?.data?.mainrecord || {})
      }
    });

    const mode = {
      options: {
        mode: "DEFAULT",
        handler: "handleDialog",
        dialog: dialogRoute
      }
    };

    setOpen(true);
    handleClickOpen(mode);
  }


  // Get the 'next' and 'pre' search parameters
  const nextValue = getQueryParam("next");
  const preValue = getQueryParam("pre");

 

  // useEffect(() => {
  //   ;
  // },[]);
  function findObjects(data, keyName, value) {
    const index = data.findIndex(item => item[keyName] === value);

    if (index === -1) {
      return null; // Return null if the object is not found
    }

    return {
      preOBJ: data[index - 1] || null,
      cruntOBJ: data[index],
      nextOBJ: data[index + 1] || null
    };
  }
  async function handleFirstItem(){
    let rowData = await localStorage.getItem('GridData')
    let dataRecords = await JSON.parse(rowData)
    let keyName= ownerFormData.form.sPrimaryKey
    const result = findObjects(dataRecords, keyName, dataRecords?.[0]?.[keyName]);
    let nextOBJ = result.nextOBJ?.[keyName] || null
    let cruntOBJ = result.cruntOBJ?.[keyName] || null
    let preOBJ = result.preOBJ?.[keyName] || null
    navigate(`${window.location.pathname}?id=${cruntOBJ}&pre=${preOBJ}&next=${nextOBJ}`);
  }
  async function handleLastItem(){
    let rowData = await localStorage.getItem('GridData')
    let dataRecords = await JSON.parse(rowData)
    let keyName= ownerFormData.form.sPrimaryKey
    const result = findObjects(dataRecords, keyName, dataRecords?.[dataRecords.length-1]?.[keyName]);
    let nextOBJ = result.nextOBJ?.[keyName] || null
    let cruntOBJ = result.cruntOBJ?.[keyName] || null
    let preOBJ = result.preOBJ?.[keyName] || null
    navigate(`${window.location.pathname}?id=${cruntOBJ}&pre=${preOBJ}&next=${nextOBJ}`);
  }
  const handleNext = async() => {
    let value = nextValue
    let keyName = ownerFormData.form.sPrimaryKey
    let rowData = await localStorage.getItem('GridData')
    let dataRecords = await JSON.parse(rowData)
    const result = findObjects(dataRecords, keyName, value);
    let nextOBJ = result.nextOBJ?.[keyName] || null
    let cruntOBJ = result.cruntOBJ?.[keyName] || null
    let preOBJ = result.preOBJ?.[keyName] || null
    navigate(`${window.location.pathname}?id=${cruntOBJ}&pre=${preOBJ}&next=${nextOBJ}`);
  };


  const handlePre = async() => {
    let value = preValue
    let keyName = ownerFormData.form.sPrimaryKey
    let rowData = await localStorage.getItem('GridData')
    let dataRecords = await JSON.parse(rowData)
    const result = findObjects(dataRecords, keyName, value);
    let nextOBJ = result.nextOBJ?.[keyName] || null
    let cruntOBJ = result.cruntOBJ?.[keyName] || null
    let preOBJ = result.preOBJ?.[keyName] || null
    navigate(`${window.location.pathname}?id=${cruntOBJ}&pre=${preOBJ}&next=${nextOBJ}`);
  };

  function getQueryParam(param) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
function replaceValueInBrackets(uri, data) {
  return uri?.replace(/\[([^\]]+)\]/g, (match, key) => {
    return data[key] || match; // Replace with value from data or leave unchanged if key not found
  });
}

  const FirstPage = data?.filter((menuItem) => menuItem.sMenuName == "First Record")?.[0];
  const LastPage = data?.filter((menuItem) => menuItem.sMenuName == "Last Record")?.[0];
  const NextPage = data?.filter((menuItem) => menuItem.sMenuName == "Next Record")?.[0];
  const PrevPage = data?.filter((menuItem) => menuItem.sMenuName == "Previous Record")?.[0];

  return (
    <>
      {/* ssS

<br /> */}
      <br />
      <br />

      {/* <br /> */}
      <br />
      <br />
      {/* {JSON.stringify(sideBarStyle)} */}
      {/* {getQueryParam('next')} */}
      {/* {JSON.stringify(formData.details)} */}
      {/* {JSON.stringify(window.location.origin)} */}
      {menu && menu !== "" && (
        <Grid container>
          <Box id={overlaySplit? 'overlay-menu': "form-menu"} sx={sideBarStyle[overlaySplit? 'overlay-menu': "form-menu"]}>
            {data?.map((navItem, ind) => (
              <Grid item {...JSON.parse(navItem?.sGridProps)}>
                <Box onMouseOver={() => setIndex(ind)} onMouseOut={() => setIndex(-1)}>
                  {ind == 0 && overlaySplit && FirstPage && (
                    <Tooltip title={FirstPage.sToolTip}>
                      <IconButton
                        onClick={() => handleFirstItem()}
                        style={{ padding: "0px 1px", color: "#000" }}
                      >
                        <Icon
                          iconName={FirstPage.sImageType}
                          sProps={JSON.parse(FirstPage?.sImageProps)}
                          dataSProps={JSON.parse(FirstPage?.sImageProps)}
                          />
                      </IconButton>
                    </Tooltip>
                  )}
                  {ind == 0 && overlaySplit && PrevPage && (
                    <Tooltip title={PrevPage.sToolTip}>
                      <IconButton
                        disabled={preValue && preValue == "null"}
                        onClick={() => handlePre()}
                        style={{ padding: "0px 1px", color: (preValue && preValue == "null") ? "#bab9b6" : "#000" }}
                      >
                        <Icon
                          iconName={PrevPage.sImageType}
                          sProps={JSON.parse(PrevPage?.sImageProps)}
                          dataSProps={JSON.parse(PrevPage?.sImageProps)}
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  {ind == 0 &&   overlaySplit && NextPage && (
                    <Tooltip title={NextPage.sToolTip}>
                      <IconButton
                       disabled={nextValue && nextValue == "null"}
                        onClick={() => handleNext()}
                        style={{ padding: "0px 1px", color: (nextValue && nextValue == "null") ? "#bab9b6" : "#000" }}
                      >
                        <Icon
                          iconName={NextPage.sImageType}
                          sProps={JSON.parse(NextPage?.sImageProps)}
                          dataSProps={JSON.parse(NextPage?.sImageProps)}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  {ind == 0 && overlaySplit && LastPage && (
                    <Tooltip title={LastPage.sToolTip}>
                      <IconButton
                        onClick={() => handleLastItem()}
                        style={{ padding: "0px 1px", color: "#000" }}
                      >
                        <Icon
                          iconName={LastPage.sImageType}
                          sProps={JSON.parse(LastPage?.sImageProps)}
                          dataSProps={JSON.parse(LastPage?.sImageProps)}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title={navItem?.sToolTip}>
                    {navItem?.sMenuContainer === "MENU" ? (
                      <Stack direction="row" sx={{ display: "flex", alignItems: "center" }}>
                        <span style={{ padding: "0px 1px", color: "#000" }}>
                          <Icon iconName={navItem?.sImageType} />
                        </span>
                        <Typography
                          position="relative"
                          onClick={() => setIndex(ind)}
                          key={navItem}
                          sx={{
                            mx: navItem?.bDisplayName ? 1 : 0,
                            color: "#000",
                            cursor: "pointer"
                          }}
                        >
                          {navItem?.bDisplayName === 1 && navItem?.sMenuName}
                        </Typography>
                      </Stack>
                    ) : navItem?.sMenuContainer === "AVATAR" ? (
                      <Avatar>P</Avatar>
                    ) : navItem?.sMenuContainer === "BUTTONDIALOG" ? (
                      <Grid {...navItem?.sMenuProps}>
                        <Button
                          id={navItem.sMenuID}
                          disabled={isMenuDisabled(navItem)}
                          // onClick={() => navigate(navItem?.sMenuRoute, { state: { dialog: true } })}
                          onClick={() => handleClickOpen1(navItem)}
                          {...parseMenuProps(navItem?.sMenuProps)}
                        >
                          {navItem.sMenuName}
                        </Button>
                      </Grid>
                    ) : navItem?.sMenuContainer === "ICON" ? (
                            <>
                              {navItem.sMenuRoute ? <IconButton
                                sx={{
                                  padding: "0px 1px",
                                  color:
                                    isMenuDisabled(navItem)
                                      ? "text.disabled"
                                      : "#000",
                                }}
                                disabled={isMenuDisabled(navItem)}
                                onClick={async () => {
                                if (navItem?.sAction === "PRINT") {
                                  try {
                                    await openPrintReport(navItem);
                                  } catch (error) {
                                    console.error("[formmenu.js] ICON PRINT failed", error);
                                  }
                                  } else {
                                    setOverLaySplit(false);
                                    const uri = resolveMenuRoute(
                                      navItem?.sMenuRoute
                                    );

                                    if (!uri) {
                                      console.error(
                                        "[formmenu.js] ICON route is empty",
                                        navItem
                                      );
                                      return;
                                    }

                                    if (hasUnresolvedMenuParameter(uri)) {
                                      console.error(
                                        "[formmenu.js] ICON route contains unresolved parameter",
                                        {
                                          routeTemplate: navItem?.sMenuRoute,
                                          resolvedRoute: uri,
                                          navItem
                                        }
                                      );
                                      return;
                                    }

                                    navigate(uri);
                                  }
                                }}
                              >
                                {navItem?.sAction === "PRINT" && printCount > 0 ? (
                                  <StyledBadge badgeContent={printCount} color="primary">
                                    <Icon
                                      sProps={JSON.parse(navItem?.sImageProps)}
                                      dataSProps={JSON.parse(navItem?.sImageProps)}
                                      iconName={navItem?.sImageType}
                                    />
                                  </StyledBadge>
                                ) : (
                                  <Icon
                                    sProps={JSON.parse(navItem?.sImageProps)}
                                    dataSProps={JSON.parse(navItem?.sImageProps)}
                                    iconName={navItem?.sImageType}
                                  />
                                )}
                              </IconButton> : <IconButton style={{ padding: "0px 1px", color: "#000" }}>
                                <Icon
                                  sProps={JSON.parse(navItem?.sImageProps)}
                                  dataSProps={JSON.parse(navItem?.sImageProps)}
                                  iconName={navItem?.sImageType}
                                />
                              </IconButton>}
                            </>
                    ) : navItem?.sMenuContainer === "ICONDIALOG" ? (() => {
                        const disabled = isMenuDisabled(navItem);

                        const imageProps = JSON.parse(navItem?.sImageProps || "{}");

                        const disabledImageProps = disabled
                          ? {
                              ...imageProps,
                              color: "disabled",
                              sx: {
                                ...(imageProps?.sx || {}),
                                color: "text.disabled"
                              }
                            }
                          : imageProps;

                        return (
                          <IconButton
                            id={navItem.sMenuID}
                            disabled={disabled}
                            onClick={() => {
                              if (disabled) return;
                              handleIconDialog(navItem);
                            }}
                            sx={{
                              padding: "0px 1px",
                              color: disabled ? "text.disabled" : "#000",
                              pointerEvents: disabled ? "none" : "auto",
                              opacity: disabled ? 0.45 : 1
                            }}
                          >
                            <Icon
                              sProps={disabledImageProps}
                              dataSProps={disabledImageProps}
                              iconName={navItem?.sImageType}
                            />
                          </IconButton>
                        );
                      })(): navItem?.sMenuContainer === "BUTTON" ? (
                      <>
                        <Button
                          id={navItem.sMenuID} // variant="contained"
                          disabled={
                            isMenuDisabled(navItem) ||
                            (navItem?.sAction === "PRINT" && printButtonDisabledStatus)
                          }
                          onClick={async e => {
                            if (navItem?.sMenuRoute) {
                              if(navItem?.sAction == "PRINT"){
                                try {
                                  await openPrintReport(navItem);
                                } catch (error) {
                                  console.error("[formmenu.js] BUTTON PRINT failed", error);
                                }
                              } else {
                                  const uri = resolveMenuRoute(
                                    navItem?.sMenuRoute
                                  );

                                  if (!uri) {
                                    console.error(
                                      "[formmenu.js] BUTTON route is empty",
                                      navItem
                                    );
                                    return;
                                  }

                                  if (hasUnresolvedMenuParameter(uri)) {
                                    console.error(
                                      "[formmenu.js] BUTTON route contains unresolved parameter",
                                      {
                                        routeTemplate: navItem?.sMenuRoute,
                                        resolvedRoute: uri,
                                        navItem
                                      }
                                    );
                                    return;
                                  }

                                  const isPostRoute =
                                    navItem?.sMenuRoute?.startsWith("POST:/");

                                  /*
                                  * A BUTTON may be clicked while the current transaction
                                  * is displayed inside OverLayDrawer.
                                  *
                                  * Close the overlay before navigating so the destination
                                  * form renders as the main form, not inside the old overlay.
                                  */
                                  setOverLaySplit(false);

                                  if (isPostRoute) {
                                    navigate(uri, {
                                      state: {
                                        method: "POST"
                                      }
                                    });
                                  } else {
                                    navigate(uri, {
                                      state: null
                                    });
                                  }

                                  setDefaultTableSelectedLocation("");
                                  setDefaultTableSelectedDataAwareData({});
                                  setDefaultTableSelectedSupplier("");
                                }
                            } else if (navItem?.submenus.length > 0) {
                              handleClick(e);
                              setPopoverId(navItem?.sMenuID);
                              setDefaultTableSelectedLocation("")
                              setDefaultTableSelectedDataAwareData({})
                              setDefaultTableSelectedSupplier("")
                            }
                          }}
                          {...JSON.parse(navItem?.sMenuProps)}
                        >
                          {/* {JSON.stringify(navItem.submenus)} */}

                          {navItem?.bDisplayName === 1 && navItem?.sMenuName}
                          {(navItem?.sImageType && navItem?.sImageType.length > 0) ||
                          navItem.submenus?.length > 0 ? (
                            <Icon iconName="ArrowDropDown" />
                          ) : null}
                        </Button>
                        {navItem?.sMenuID == popoverId && <Popover
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right"
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right"
                          }}
                        >
                          <List>
                            {navItem?.submenus?.map((item, index) => {
                              const resolvedRoute = resolveMenuRoute(
                                item?.sMenuRoute
                              );

                              const routeInvalid =
                                !resolvedRoute ||
                                hasUnresolvedMenuParameter(resolvedRoute);

                              return (
                                <ListItem key={index}>
                                  {item.sCaption === "Export Chart of Accounts" ? (
                                    <Typography
                                      className="cursor-poniter"
                                      onClick={() => {
                                        if (routeInvalid) {
                                          console.error(
                                            "[formmenu.js] BUTTON submenu export route is invalid",
                                            {
                                              routeTemplate: item?.sMenuRoute,
                                              resolvedRoute
                                            }
                                          );
                                          return;
                                        }

                                        downloadCsV(
                                          resolvedRoute,
                                          item.sCaption
                                        );
                                      }}
                                    >
                                      {item.sCaption}
                                    </Typography>
                                  ) : (
                                    <Link
                                      to={routeInvalid ? "#" : resolvedRoute}
                                      onClick={event => {
                                        if (routeInvalid) {
                                          event.preventDefault();

                                          console.error(
                                            "[formmenu.js] BUTTON submenu route is invalid",
                                            {
                                              routeTemplate: item?.sMenuRoute,
                                              resolvedRoute
                                            }
                                          );

                                          return;
                                        }

                                        handleClose();
                                        setOverLaySplit(false);
                                      }}
                                    >
                                      <Typography>
                                        {item.sCaption}
                                      </Typography>
                                    </Link>
                                  )}
                                </ListItem>
                              );
                            })}
                          </List>
                        </Popover>}
                      </>
                    ) : navItem?.sMenuContainer === "ELIPSIS" ? (
                      <>
                        {/* {navItem.sAction} */}
                        <IconButton
                          id={navItem.sMenuID}
                          disabled={isMenuDisabled(navItem)}
                          sx={{ cursor: "pointer" }}
                          onClick={handleClick2}
                        >
                          <MoreHorizOutlinedIcon
                            aria-describedby={id}
                            // aria-describedby={id}
                            // variant="contained"
                          />
                        </IconButton>
                        <Popover
                          id={id}
                          open={open1}
                          anchorEl={anchorEl1}
                          onBlur={handleClose2}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center"
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center"
                          }}
                        >
                          <List>
                            {navItem?.submenus?.map((item, index) => {
                              const isDisabled = BUTTONDIALOG[item.sMenuID];
                              return (
                                <ListItem key={index}>
                                  {item.sMenuRoute.includes('/export/') ? (
                                    <Typography
                                      className={`${isDisabled ? 'text-neutral-400' : 'cursor-pointer'}`}
                                      onClick={() => {
                                        if (isDisabled) return;

                                        const uri = resolveMenuRoute(
                                          item?.sMenuRoute
                                        );

                                        if (!uri || hasUnresolvedMenuParameter(uri)) {
                                          console.error(
                                            "[formmenu.js] ELIPSIS export route is invalid",
                                            {
                                              routeTemplate: item?.sMenuRoute,
                                              resolvedRoute: uri
                                            }
                                          );
                                          return;
                                        }

                                        downloadCsV(
                                          uri,
                                          item.sCaption
                                        );
                                      }}
                                    >
                                      {item.sCaption}
                                    </Typography>
                                  ) : (
                                    <Typography 
                                      className={isDisabled ? "text-neutral-400" : "cursor-pointer"}
                                      onClick={() => {
                                        if (isDisabled) return;

                                        const uri = resolveMenuRoute(
                                          item?.sMenuRoute
                                        );

                                        if (!uri || hasUnresolvedMenuParameter(uri)) {
                                          console.error(
                                            "[formmenu.js] ELIPSIS route is invalid",
                                            {
                                              routeTemplate: item?.sMenuRoute,
                                              resolvedRoute: uri
                                            }
                                          );
                                          return;
                                        }

                                        setOverLaySplit(false);
                                        handleClose2();
                                        navigate(uri, {
                                          state: null
                                        });
                                      }}
                                    >
                                      {item.sCaption}
                                    </Typography>
                                  )}
                                </ListItem>
                              );
                            })}
                          </List>
                        </Popover>
                      </>
                    ) : navItem?.sMenuContainer === "SELECTED" ? (
                      <SimpleListMenu data={navItem} />
                    ) : null}
                  </Tooltip>
                  {navItem.submenu && index === ind && (
                    <Box
                      open={index === ind}
                      onClick={() => setIndex(-1)}
                      anchorEl={anchorEl}
                      sx={{
                        position: "absolute",
                        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 2px",
                        p: "2rem 1rem .5rem 1rem",
                        cursor: "pointer",
                        backgroundColor: "#fff",
                        zIndex: "5"
                      }}
                    >
                      {index === ind &&
                        navItem.submenus !== undefined &&
                        navItem?.submenus?.map(menu => {
                          const resolvedRoute = resolveMenuRoute(
                            menu?.sMenuRoute
                          );

                          const routeInvalid =
                            !resolvedRoute ||
                            hasUnresolvedMenuParameter(resolvedRoute);

                          return (
                            <Link
                              key={menu?.sMenuID || menu?.sCaption}
                              to={routeInvalid ? "#" : resolvedRoute}
                              onClick={event => {
                                if (routeInvalid) {
                                  event.preventDefault();

                                  console.error(
                                    "[formmenu.js] MENU submenu route is invalid",
                                    {
                                      routeTemplate: menu?.sMenuRoute,
                                      resolvedRoute
                                    }
                                  );

                                  return;
                                }

                                handleClose();
                                setOverLaySplit(false);
                              }}
                            >
                              <Tooltip title={menu.sToolTip}>
                                <Typography className="menu-close">
                                  {menu.sCaption}

                                  <span>
                                    <IconButton>
                                      <Icon
                                        iconName={
                                          menu?.sDefaultActionImage
                                        }
                                      />
                                    </IconButton>
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Link>
                          );
                        })}
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
          </Box>

          {/* ends user */}
          <Box
            sx={{
              flexGrow: !toggle ? 1 : 0,
              display: { xs: "flex", md: "none" },
              color: "black",
              justifyContent: "flex-end"
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" }
              }}
            >
              {data?.map(navItem => (
                <Box>
                  {navItem?.bDisplayName === 1 && (
                    <MenuItem onClick={handleCloseNavMenu} textAlign="center">
                      {navItem.sMenuName}
                    </MenuItem>
                  )}
                  {/* <Typography textAlign="center">{navItem?.submenu?.map((subMenu)=>{
                    <Typography>{subMenu?.sCaption}</Typography>
                  })}</Typography> */}
                </Box>
              ))}
            </Menu>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default FormBar;
